/**
 * hc-upsell-claim.js   (must load BEFORE hc-fixes.js)
 *
 * hc-fixes.js contains an older upsell renderer. hc-upsell-rows.js replaces it
 * with one that keeps per-variant prices on the <option> elements, so the size
 * dropdown updates the price without a network call.
 *
 * Both would otherwise render into the same <ul> and fight. hc-fixes.js skips
 * any .hc-upsell block already marked with __hcx, so we claim them here first.
 * The tier bar and confetti in hc-fixes.js are unaffected.
 */
(function () {
  'use strict';

  function claim() {
    document.querySelectorAll('.hc-upsell').forEach(function (el) {
      el.__hcx = true;                  // tells hc-fixes.js: not yours
      el.__hcxRender = function () {};  // no-op if it calls back in
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', claim);
  } else {
    claim();
  }

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(claim, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });

  claim();
})();
